module.exports = __webpack_public_path__ + "img/icon-ai-purple.6c2594d5.svg";